import { addBaseUrlToUrls, commonEnvironment } from "./environment.common";

export const environment = {
	...commonEnvironment,
	production: false,
	baseUrl: 'https://dev-api.kastenman.be',
	odooUrl: '',
	// No Odoo backend in dev → the offerte form falls back to a mailto.
	crmLeadUrl: '',
	// Dev has no Odoo URL: mock the sale-order lines so the quotation flow is testable.
	quotationMockOrderLines: true,
	// Round elements are built on dev only; other stages ship the code dormant.
	roundElements: true,
	cognito: {
		REGION: 'eu-central-1',
		USER_POOL_ID: 'eu-central-1_VBjMjMqN4',
		APP_CLIENT_ID: '19qpvdb5mjlb24chhku9shu91p',
		IDENTITY_POOL_ID: 'eu-central-1:011b7304-f897-4ea4-bf02-641b5cad2ed6',
	},
	wsUrl: 'wss://dev-ws.kastenman.be'
};

addBaseUrlToUrls(environment, commonEnvironment);


